export default "__VITE_ASSET__fR9et2zt__"